import { render, staticRenderFns } from "./userscomponent.vue?vue&type=template&id=2641b26e&"
import script from "./userscomponent.vue?vue&type=script&lang=ts&"
export * from "./userscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports